<ng-template [ngIf]="(message$ | async)?.length">{{message$ | async}} In Progress</ng-template>